<template>

    <div>

        <div class="row align-items-center">
            <div class="col" style="top: 2px;">
                <h5 class="mb-0" style="padding-left: 0.9375rem;">{{ machine.name ? machine.name : machine.serial_number }}</h5>
            </div>
            <div class="col-auto text-right">
                <a class="btn btn-icon btn-primary btn-sm m-0" :href="route('machine::machines.edit', {id: machine.id})" v-if="userHasPermission('machines.machine.edit')" :title="t.__('Właściwości')"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                <a class="btn btn-icon btn-primary btn-sm m-0" :href="route('machine::machines.edit-menu', {id: machine.id})" v-if="userHasPermission('machines.menu.show')" :title="t.__('Ustawienia menu')"><i class="fa fa-list-ul" aria-hidden="true"></i></a>
                <a class="btn btn-icon btn-primary btn-sm m-0" :href="route('machine::machines.edit-packages', {id: machine.id})" v-if="userHasPermission('machines.packages.show')" :title="t.__('Pakiety')"><i class="fa fa-th-large" aria-hidden="true"></i></a>
                <a class="btn btn-icon btn-info btn-sm m-0" :href="route('queue::jobs.index') + '?machine-ids[]=' + machine.id" v-if="userHasPermission('queue.jobs.show')" :title="t.__('Kolejka zadań')"><i class="fa fa-clock-o" aria-hidden="true"></i></a>
                <a class="btn btn-icon btn-warning btn-sm m-0" :href="route('machine::machines.access-shell', {id: machine.id})" target="_blank" v-if="userHasPermission('machines.run_shell.show')" :title="t.__('Shell')"><i class="fa fa-terminal" aria-hidden="true"></i></a>
                <a class="btn btn-icon btn-warning btn-sm m-0" :href="route('machine::machines.access-vnc', {id: machine.id})" target="_blank" v-if="userHasPermission('machines.run_vnc.show')" :title="t.__('VNC')"><i class="fa fa-desktop" aria-hidden="true"></i></a>
                <div class="dropdown d-inline m-0">
                    <button type="button" class="btn btn-icon btn-primary btn-sm m-0" title="Inne akcje" id="machine-actions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-chevron-down" aria-hidden="true"></i></button>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="machine-actions">
                        <a class="dropdown-item" :href="route('machine::machines.access-cal', {id: machine.id})" target="_blank" v-if="userHasPermission('machines.run_cal.show')">{{ t.__('CAL') }}</a>
                        <a class="dropdown-item" href="#" v-if="userHasPermission('machines.download_firmware.show')">{{ t.__('Pobierz firmware') }}</a>
                        <div class="dropdown-divider" v-if="qActions.length > 0"></div>
                        <a class="dropdown-item" href="#" v-for="qAction in qActions" @click="runCommand(qAction.subcommand)">{{ qAction.label }}</a>
                    </div>
                </div>
            </div>
        </div>

        <table class="table mt-5">
            <tr v-if="userHasPermission('machines.serial_number.show')">
                <td>{{ t.__('Numer seryjny') }}</td>
                <td v-html="machine.serial_number"></td>
            </tr>
            <tr v-if="userHasPermission('machines.name.show')">
                <td>{{ t.__('Nazwa') }}</td>
                <td v-html="displayContent(machine.name)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.is_online.show')">
                <td>{{ t.__('Stan') }}</td>
                <td>
                    <span class="text-success" v-if="machine.is_online">{{ t.__('Online') }}</span>
                    <span class="text-danger" v-if="!machine.is_online">{{ t.__('Offline') }}</span>
                </td>
            </tr>
            <tr v-if="userHasPermission('machines.last_seen.show')">
                <td>{{ t.__('Ostatnio widziane') }}</td>
                <td v-html="displayContent(machine.last_seen)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.type.show')">
                <td>{{ t.__('Typ') }}</td>
                <td v-html="displayContent(machine.type ? machine.type.name : null)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.menu_type.show')">
                <td>{{ t.__('Rodzaj oprogramowania') }}</td>
                <td v-html="displayContent(machine.software_type)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.mac_address.show')">
                <td>{{ t.__('Adres MAC') }}</td>
                <td v-html="displayContent(machine.mac)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.hostname.show')">
                <td>{{ t.__('Nazwa hosta') }}</td>
                <td v-html="displayContent(machine.hostname)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.ip_address.show')">
                <td>{{ t.__('Adres IP') }}</td>
                <td v-html="displayContent(machine.ip)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.ip_wan_address.show')">
                <td>{{ t.__('Adres IP WAN') }}</td>
                <td v-html="displayContent(machine.ip_wan)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.ip_lan_address.show')">
                <td>{{ t.__('Adres IP LAN') }}</td>
                <td v-html="displayContent(machine.ip_lan)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.interface.show')">
                <td>{{ t.__('Interfejs sieciowy') }}</td>
                <td v-html="displayContent(machine.interface)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.image_version.show')">
                <td>{{ t.__('Wersja obrazu') }}</td>
                <td v-html="displayContent(machine.image_version)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.firmware_version.show')">
                <td>{{ t.__('Wersja firmware') }}</td>
                <td v-html="displayContent(machine.firmware_version)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.summary.show')">
                <td>{{ t.__('Status') }}</td>
                <td v-html="displayContent(machine.summary)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.settings_fan.show')">
                <td>{{ t.__('Moc chłodzenia (wiatraczka)') }}</td>
                <td v-html="displayContentPercent(machine.settings_fan)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.uptime.show')">
                <td>{{ t.__('Czas działania') }}</td>
                <td v-html="displayContent(machine.uptime)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.notes.show')">
                <td>{{ t.__('Uwagi') }}</td>
                <td v-html="displayContent(machine.notes)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.repo.show')">
                <td>{{ t.__('Repozytorium') }}</td>
                <td>
                    <template v-if="machine.repo === 'dev'">{{ t.__('Deweloperskie') }}</template>
                    <template v-else-if="machine.repo === 'test'">{{ t.__('Testowe') }}</template>
                    <template v-else-if="machine.repo === 'prod'">{{ t.__('Produkcyjne') }}</template>
                    <template v-else>{{ machine.repo }}</template>
                </td>
            </tr>
            <tr v-if="userHasPermission('machines.autoupdate.show')">
                <td>{{ t.__('Automatyczne aktualizacje') }}</td>
                <td v-html="machine.autoupdate ? t.__('Tak') : t.__('Nie')"></td>
            </tr>
            <tr v-if="userHasPermission('machines.enable_onevo_cast.show')">
                <td>{{ t.__('Włączone onEVO cast') }}</td>
                <td v-html="machine.enable_onevo_cast ? t.__('Tak') : t.__('Nie')"></td>
            </tr>
            <tr v-if="userHasPermission('machines.language.show')">
                <td>{{ t.__('Język') }}</td>
                <td v-html="displayContent(machine.language.toUpperCase())"></td>
            </tr>
            <tr v-if="userHasPermission('machines.timezone.show')">
                <td>{{ t.__('Strefa czasowa') }}</td>
                <td v-html="displayContent(machine.timezone)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.geoip.show')">
                <td>{{ t.__('GeoIP') }}</td>
                <td v-html="displayContent(machine.geoip_full)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.packages_synchronization_date.show')">
                <td>{{ t.__('Synchronizacja pakietów') }}</td>
                <td v-html="displayContent(machine.packages_synchronization_date)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.menu_synchronization_date.show')">
                <td>{{ t.__('Synchronizacja menu') }}</td>
                <td v-html="displayContent(machine.menu_synchronization_date)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.sell_date.show')">
                <td>{{ t.__('Data sprzedaży') }}</td>
                <td v-html="displayContent(machine.sell_date)"></td>
            </tr>
            <tr v-if="userHasPermission('machines.production_date.show')">
                <td>{{ t.__('Data produkcji') }}</td>
                <td v-html="displayContent(machine.production_date)"></td>
            </tr>

        </table>

    </div>

</template>

<script>
    export default {

        name: 'MachineDetails',

        props: [
            'machine',
            'qActions'
        ],

        data() {
            return {
                eventHub: window.eventHub,
            }
        },

        mounted() {
            Echo.private('machine.' + this.machine.id)
                .listen('.machine.updated', (e) => {
                    this.machine = e.machine;
                });
        },

        methods: {
            displayContent: (content) => {
                if (content) {
                    return content;
                } else {
                    return '<i>-- ' + t.__('Brak danych') + ' --</i>';
                }
            },

            displayContentPercent: (content) => {
                if (content) {
                    return content + '%';
                } else {
                    return '<i>-- ' + t.__('Brak danych') + ' --</i>';
                }
            },

            runCommand(command) {
                this.eventHub.$emit('processing-start');
                axios.get(route('machine::machines.run-command', {id: this.machine.id, command: command}))
                    .then(response => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch(response => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                    });
            }
        }

    }
</script>

<style scoped>

</style>
